import { useEffect, useState } from 'react';
import qs from 'query-string';

import { QUERY_PARAMS } from '../Callback/Constants';
import Spinner from '../Spinner';
import ErrorView from '../ErrorView';
import { URLS } from '../../constants';

const Auth = () => {
  const [error, setError] = useState(false);

  useEffect(() => {
    const queryParams = qs.parse(window.location.search);
    const requestId = queryParams[QUERY_PARAMS.REQUEST_ID];
    const bankId = queryParams[QUERY_PARAMS.BANK_ID];
    const callbackUrl = queryParams[QUERY_PARAMS.CALLBACK_URL];

    const validRequest = requestId && bankId;
    if (!validRequest) {
      setError(true);
    } else {
      let redirectUrl = `${URLS.AUTHENTICATE}?request-id=${requestId}&bank-id=${bankId}`;
      if (callbackUrl) {
        redirectUrl += `&callback-url=${callbackUrl}`;
      }

      window.location.replace(redirectUrl);
    }
  }, []);

  return (
    <>
      {!error && <Spinner />}
      {error && <ErrorView showGoBackButton />}
    </>
  );
};

export default Auth;
